<template>
  <div class='EnbCategory'>
    <div class="cont">
      <category-list
      v-for="(l, key) in Categorys"
      :key="key"
      :data="l"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import CategoryList from './CategoryList'
export default {
  name: 'EnbCategory',
  components: { CategoryList },
  data () {
    return {
      Categorys: []
    }
  },
  methods: {
    ...mapActions(['GetFrenteLojaCategoria'])
  },
  created () {
    this.GetFrenteLojaCategoria()
      .then(res => {
        this.Categorys = res
      })
  }
}
</script>

<style scoped>
.EnbCategory {
  width: 100%;
  /* height: 100%; */
}

.text {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  font-weight: bold;
  width: 96%;
  padding: 2%;
}

/* grid de colunas fixas: o bloco fica centralizado e os cards que sobram na última linha ficam à esquerda */
.cont {
  width: 70%;
  /* height: 95%; */
  margin: auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, 180px);
  justify-content: center;
  gap: 20px;
  padding: 20px 0;
  overflow: auto;
}

.cont > .CategoryList {
  margin: 0;
}

@media (max-width: 500px) {
  .cont {
    width: 100%;
    gap: 10px;
  }
  
  .text {
    width: 90%;
    padding: 5%;
  }
}
</style>
